import { FlexRow } from '@synqo/frontend-component-library';
import type { ReactNode } from 'react';
import classes from './PanelFooter.module.css';

/** The strip under the content of a panel or modal that holds its actions, set off by a divider. */
// @ai-generated 2026-10-30T09:00:00Z by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function PanelFooter({ children }: { children: ReactNode }) {
    return (
        <FlexRow className={classes.footer} justify="flex-end">
            {children}
        </FlexRow>
    );
}
